module.exports = __webpack_public_path__ + "static/img/no-coupon.bedbc5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/no-coupon.png
// module id = NnCp
// module chunks = 1